import { render, staticRenderFns } from "./WorkshopTypeForm.vue?vue&type=template&id=02491287&"
import script from "./WorkshopTypeForm.vue?vue&type=script&lang=js&"
export * from "./WorkshopTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports